import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en_us from './locales/en_us.json';
import fr_fr from './locales/fr_fr.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en_us },
      fr: { translation: fr_fr },
    },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
